import { configureStore } from "@reduxjs/toolkit";
import { createLogger } from "redux-logger";

import { SampleReducer } from "./Slices/Sample/Sample.slice";
import { BusAdminReducer } from "./Slices/BusAdmin/BusAdmin.slice";
import { BusAssociationReducer } from "./Slices/BusAssociation/BusAssociation.slice";
import { AgentReducer } from "./Slices/Agent/Agent.slice";
import { BusStructureReducer } from "./Slices/BusStructure/BusStructure.slice";
import { BusReducer } from "./Slices/Bus/Bus.slice";
import { ConductorReducer } from "./Slices/Conductor/Conductor.slice";
import { DriverReducer } from "./Slices/Driver/Driver.slice";
import { FinanceAuditReducer } from "./Slices/FinanceAudit/FinanceAudit.slice";

import { TopUpRequestReducer } from "./Slices/TopUpRequest/TopUpRequest.slice";
import { CancellationPolicyReducer } from "./Slices/CancellationPolicy/CancellationPolicy.slice";
import { AmenitiesReducer } from "./Slices/Amenities/Amenities.slice";
import { AccountReducer } from "./Slices/Account/Account.slice";
import { TermsAndConditionsReducer } from "./Slices/TermsAndConditions/TermsAndConditions.slice";
import { CityReducer } from "./Slices/City/City.slice";
import { TripReducer } from "./Slices/Trip/Trip.slice";
import { CustomerReducer } from "./Slices/Customer/Customer.slice";
import { TicketReducer } from "./Slices/Ticket/Ticket.slice";
import { RouteReducer } from "./Slices/Route/Route.slice";
import { ReportReducer } from "./Slices/Report/Report.slice";
import { CancellationRequestReducer } from "./Slices/CancellationRequest/CancellationRequest.slice";
import { DashboardReducer } from "./Slices/Dashboard/Dashboard.slice";
import { LogReducer } from "./Slices/Log/Log.slice";
import { AccessControlReducer } from "./Slices/Access-control/Access-control.slice";
import { B2BBookingReducer } from "./Slices/B2b/B2b.slice";

export * from "./Slices/Sample/Sample.slice";
export * from "./Slices/BusAdmin/BusAdmin.slice";
export * from "./Slices/BusAssociation/BusAssociation.slice";
export * from "./Slices/Agent/Agent.slice";
export * from "./Slices/BusStructure/BusStructure.slice";
export * from "./Slices/Bus/Bus.slice";
export * from "./Slices/Conductor/Conductor.slice";
export * from "./Slices/Driver/Driver.slice";
export * from "./Slices/TopUpRequest/TopUpRequest.slice";
export * from "./Slices/CancellationPolicy/CancellationPolicy.slice";
export * from "./Slices/Amenities/Amenities.slice";
export * from "./Slices/Account/Account.slice";
export * from "./Slices/TermsAndConditions/TermsAndConditions.slice";
export * from "./Slices/City/City.slice";
export * from "./Slices/Trip/Trip.slice";
export * from "./Slices/Customer/Customer.slice";
export * from "./Slices/Ticket/Ticket.slice";
export * from "./Slices/Route/Route.slice";
export * from "./Slices/Report/Report.slice";
export * from "./Slices/CancellationRequest/CancellationRequest.slice";
export * from "./Slices/Dashboard/Dashboard.slice";
export * from "./Slices/FinanceAudit/FinanceAudit.slice";
export * from "./Slices/Log/Log.slice";

const middlewares: any = [];
const logger = createLogger({ collapsed: false });
middlewares.push(logger);

const Store = configureStore({
  reducer: {
    sample: SampleReducer,
    bus_admin: BusAdminReducer,
    bus_association: BusAssociationReducer,
    agent: AgentReducer,
    bus_structure: BusStructureReducer,
    bus: BusReducer,
    conductor: ConductorReducer,
    driver: DriverReducer,
    top_up_request: TopUpRequestReducer,
    cancellation_policy: CancellationPolicyReducer,
    amenities: AmenitiesReducer,
    account: AccountReducer,
    terms_and_conditions: TermsAndConditionsReducer,
    city: CityReducer,
    trip: TripReducer,
    customer: CustomerReducer,
    ticket: TicketReducer,
    route: RouteReducer,
    report: ReportReducer,
    cancellation_request: CancellationRequestReducer,
    dashboard: DashboardReducer,
    finance_audit: FinanceAuditReducer,
    log: LogReducer,
    access_control: AccessControlReducer,
    b2b: B2BBookingReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      immutableCheck: false,
      serializableCheck: false,
    }).concat(middlewares),
  devTools: false,
});

export type RootState = ReturnType<typeof Store.getState>;
export type AppDispatch = typeof Store.dispatch;
export default Store;
